import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_CONFIG from './config/api';
import { BpsContasPagar, BpsFornecedores, BpsLimites, BpsCategorias } from './BpsFinanceiro';

export default function BpsPortal() {
  const [checking, setChecking] = useState(true);
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verify = async () => {
      const token = localStorage.getItem('bps_token');
      const savedUser = localStorage.getItem('bps_user');
      if (!token || !savedUser) {
        setChecking(false);
        return;
      }
      try {
        const response = await axios.post(`${API_CONFIG.API_URL}/auth/bps-verify`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (response.data.success) {
          // O módulo financeiro reutiliza as chamadas autenticadas do portal.
          // Mantemos o token BPS em um backup para não interferir no login Vetim.
          if (!localStorage.getItem('bps_previous_token')) {
            const tokenVetim = localStorage.getItem('token');
            if (tokenVetim) localStorage.setItem('bps_previous_token', tokenVetim);
          }
          localStorage.setItem('token', token);
          setUser(JSON.parse(savedUser));
        } else {
          localStorage.removeItem('bps_token');
          localStorage.removeItem('bps_user');
        }
      } catch (_) {
        localStorage.removeItem('bps_token');
        localStorage.removeItem('bps_user');
      } finally {
        setChecking(false);
      }
    };
    verify();
  }, []);

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      const response = await axios.post(`${API_CONFIG.API_URL}/auth/bps-login`, {
        username: formData.username,
        password: formData.password
      });
      if (response.data.success) {
        localStorage.setItem('bps_token', response.data.token);
        localStorage.setItem('bps_user', JSON.stringify(response.data.user));
        const tokenVetim = localStorage.getItem('token');
        if (tokenVetim) localStorage.setItem('bps_previous_token', tokenVetim);
        localStorage.setItem('token', response.data.token);
        setUser(response.data.user);
      }
    } catch (error) {
      setMessage(error.response?.data?.message || 'Erro ao conectar com o servidor');
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    const tokenVetim = localStorage.getItem('bps_previous_token');
    if (tokenVetim) localStorage.setItem('token', tokenVetim);
    else localStorage.removeItem('token');
    localStorage.removeItem('bps_previous_token');
    localStorage.removeItem('bps_token');
    localStorage.removeItem('bps_user');
    setUser(null);
    setFormData({ username: '', password: '' });
    setMessage('');
  };

  if (checking) {
    return <div style={{ padding: 24 }}>Verificando acesso...</div>;
  }

  if (user) {
    return (
      <BpsDashboard user={user} onLogout={logout} />
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%)', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 420, background: '#fff', borderRadius: 18, padding: 28, boxShadow: '0 10px 30px rgba(15,23,42,0.08)', border: '1px solid #e2e8f0' }}>
        <div style={{ marginBottom: 22 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: '#2563eb', letterSpacing: 1 }}>BPS</div>
          <h1 style={{ margin: '6px 0 4px', color: '#0f172a' }}>Acesso contas a pagar</h1>
          <p style={{ margin: 0, color: '#64748b' }}>Entre com seu usuário e senha para acessar o dashboard.</p>
        </div>
        <form onSubmit={login} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label style={{ display: 'block', fontSize: 14, fontWeight: 600, marginBottom: 6 }}>Usuário</label>
            <input value={formData.username} onChange={(e) => setFormData({ ...formData, username: e.target.value })} style={{ width: '100%', padding: 12, borderRadius: 12, border: '1px solid #cbd5e1' }} />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 14, fontWeight: 600, marginBottom: 6 }}>Senha</label>
            <input type="password" value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} style={{ width: '100%', padding: 12, borderRadius: 12, border: '1px solid #cbd5e1' }} />
          </div>
          {message && <div style={{ color: '#b91c1c', background: '#fee2e2', padding: 10, borderRadius: 10 }}>{message}</div>}
          <button disabled={loading} style={{ padding: 12, borderRadius: 12, border: 'none', background: '#2563eb', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}

function BpsDashboard({ user, onLogout }) {
  const [modulo, setModulo] = useState('inicio');
  const nome = user?.nome || user?.username || 'Administrador';
  const iniciais = nome.split(' ').filter(Boolean).slice(0, 2).map(p => p[0]).join('').toUpperCase();
  const [dias, setDias] = useState(7);
  const [agenda, setAgenda] = useState({ hoje: [], proximas: [] });
  const [compras, setCompras] = useState({ total: 0, limite: 0 });
  useEffect(() => { if (modulo !== 'inicio') return; axios.get(`${API_CONFIG.API_URL}/bps/overview`, { headers: { Authorization: `Bearer ${localStorage.getItem('bps_token')}` }, params: { dias } }).then(r => { setAgenda({ hoje: r.data.hoje || [], proximas: r.data.proximas || [] }); setCompras({ total: r.data.comprasMes || 0, limite: r.data.limiteCompras || 0 }); }).catch(() => {}); }, [modulo, dias]);
  const linhaConta = c => <div key={c._id} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:12, padding:'13px 0', borderBottom:'1px solid #eef2f7' }}><div><div style={{fontWeight:750,color:'#1e293b'}}>{c.descricao}</div><div style={{fontSize:12,color:'#64748b',marginTop:4}}>{new Date(c.data_vencimento).toLocaleDateString('pt-BR',{timeZone:'UTC'})} · {c.fornecedor || c.categoria}</div></div><div style={{fontWeight:800,color:'#1d4ed8',whiteSpace:'nowrap'}}>{Number(c.valor || 0).toLocaleString('pt-BR',{style:'currency',currency:'BRL'})}</div></div>;

  return (
    <div style={{ minHeight: '100vh', display: 'flex', background: '#f5f7fb', color: '#172033', fontFamily: 'Inter, system-ui, -apple-system, sans-serif' }}>
      <aside style={{ width: 248, flexShrink: 0, background: 'linear-gradient(180deg,#102a56 0%,#173d73 100%)', color: '#fff', display: 'flex', flexDirection: 'column', padding: '28px 16px 18px', boxShadow: '8px 0 24px rgba(15,23,42,.08)' }}>
        <div style={{ padding: '0 14px 28px', borderBottom: '1px solid rgba(255,255,255,.14)' }}>
          <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: 2, color: '#93c5fd' }}>PREMIUM BEEF</div>
          <div style={{ fontSize: 24, fontWeight: 800, marginTop: 5, letterSpacing: -.5 }}>Financeiro</div>
          <div style={{ fontSize: 12, color: '#bfdbfe', marginTop: 6 }}>Painel de contas a pagar</div>
        </div>
        <nav style={{ display: 'flex', flexDirection: 'column', gap: 7, marginTop: 24 }}>
          {[['inicio', '⌂', 'Visão geral'], ['contas', '▣', 'Contas a pagar'], ['fornecedores', '♙', 'Fornecedores'], ['categorias', '◇', 'Categorias'], ['limites', '◈', 'Limites']].map(([id, icon, label]) => (
            <button key={id} onClick={() => setModulo(id)} style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%', padding: '13px 14px', border: 0, borderRadius: 11, cursor: 'pointer', textAlign: 'left', color: modulo === id ? '#12305f' : '#dbeafe', background: modulo === id ? '#fff' : 'transparent', fontWeight: modulo === id ? 750 : 550, fontSize: 14 }}>
              <span style={{ width: 22, textAlign: 'center', fontSize: 19 }}>{icon}</span>{label}
            </button>
          ))}
        </nav>
        <div style={{ marginTop: 'auto', borderTop: '1px solid rgba(255,255,255,.14)', padding: '18px 10px 0' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '0 5px 14px' }}>
            <span style={{ width: 34, height: 34, borderRadius: '50%', display: 'grid', placeItems: 'center', background: '#60a5fa', color: '#12305f', fontWeight: 800, fontSize: 12 }}>{iniciais}</span>
            <div style={{ minWidth: 0 }}><div style={{ fontSize: 13, fontWeight: 700, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{nome}</div></div>
          </div>
          <button onClick={onLogout} style={{ width: '100%', padding: '11px 14px', background: 'rgba(255,255,255,.1)', color: '#fff', border: '1px solid rgba(255,255,255,.2)', borderRadius: 10, cursor: 'pointer', textAlign: 'left', fontWeight: 650 }}>↪&nbsp; Sair</button>
        </div>
      </aside>
      <main style={{ flex: 1, minWidth: 0, padding: '34px clamp(18px, 4vw, 52px)', overflow: 'auto' }}>
        {modulo === 'contas' ? <BpsContasPagar /> : modulo === 'fornecedores' ? <BpsFornecedores /> : modulo === 'categorias' ? <BpsCategorias /> : modulo === 'limites' ? <BpsLimites /> : (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 18, marginBottom: 30 }}>
              <div><div style={{ color: '#2563eb', fontSize: 12, fontWeight: 800, letterSpacing: 1.3, textTransform: 'uppercase' }}>Dashboard</div><h1 style={{ fontSize: 'clamp(25px,3vw,34px)', margin: '7px 0 8px', letterSpacing: -.8 }}>Olá, {nome.split(' ')[0]} 👋</h1><p style={{ margin: 0, color: '#64748b', fontSize: 15 }}>Acompanhe a saúde financeira da Premium Beef em um só lugar.</p></div>
              <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: '10px 14px', color: '#64748b', fontSize: 12 }}>Hoje · {new Date().toLocaleDateString('pt-BR')}</div>
            </div>
            <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:16}}><h2 style={{margin:0,fontSize:20}}>Agenda financeira</h2></div>
            <section style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(280px,1fr))',gap:16}}>
              <div style={{background:'#fff',border:'1px solid #e2e8f0',borderRadius:16,padding:'18px 20px',borderTop:'4px solid #2563eb'}}><div style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:10,flexWrap:'wrap'}}><h3 style={{margin:0,fontSize:16}}>Contas a vencer</h3><label style={{fontSize:12,color:'#64748b'}}>Próximos <select value={dias} onChange={e=>setDias(Number(e.target.value))} style={{padding:'7px 9px',border:'1px solid #dbe3ef',borderRadius:8,marginLeft:5}}><option value="3">3 dias</option><option value="7">7 dias</option><option value="15">15 dias</option><option value="30">30 dias</option></select></label></div><div style={{fontSize:12,color:'#64748b',marginTop:7,marginBottom:4}}>Vencendo hoje e nos próximos {dias} dias</div>{[...agenda.hoje, ...agenda.proximas].length ? [...agenda.hoje, ...agenda.proximas].map(linhaConta) : <div style={{padding:'22px 0 10px',color:'#94a3b8',fontSize:14}}>Nenhuma conta neste período.</div>}</div>
              <div style={{background:'#fff',border:'1px solid #e2e8f0',borderRadius:16,padding:'18px 20px'}}><h3 style={{margin:'0 0 14px',fontSize:16}}>Limite de compras</h3><div style={{display:'flex',justifyContent:'center'}}><div style={{width:280,height:140,position:'relative',overflow:'hidden',borderRadius:'280px 280px 0 0',background:'conic-gradient(from 270deg at 50% 100%,#22c55e 0deg 54deg,#facc15 54deg 144deg,#ef4444 144deg 180deg,#e2e8f0 180deg 180deg)'}}><div style={{position:'absolute',inset:'18px 18px 0',background:'#fff',borderRadius:'260px 260px 0 0'}}/><div style={{position:'absolute',bottom:0,left:'50%',width:3,height:105,background:'#172033',transformOrigin:'50% 100%',transform:`translateX(-50%) rotate(${-90 + (compras.limite ? Math.min(compras.total/compras.limite,1)*180 : 0)}deg)`,borderRadius:3}}/><div style={{position:'absolute',bottom:-5,left:'50%',width:14,height:14,borderRadius:'50%',background:'#172033',transform:'translateX(-50%)'}}/></div></div><div style={{textAlign:'center',marginTop:4,fontSize:22,fontWeight:850}}>{compras.limite ? `${Math.round(compras.total/compras.limite*100)}%` : '0%'}</div><div style={{textAlign:'center',fontSize:12,color:'#64748b',marginTop:3}}>{Number(compras.total).toLocaleString('pt-BR',{style:'currency',currency:'BRL'})} de {Number(compras.limite).toLocaleString('pt-BR',{style:'currency',currency:'BRL'})}</div></div>
            </section>
          </>
        )}
      </main>
    </div>
  );
}
